/**
 * use-payment-method-settings — paymentMethodSettingsApi（ADM-APP-S013 支付方式图标配置）
 *
 * 契约源 dev-docs `02-API契约/A8-运营支付.md` §7.8.5~§7.8.7。读写都是 per App × per **支付方式**
 * （`03-数据字典/70-产品配置.md` §3「两层闭集」的 `PAYMENT_METHODS` 层）—— 图标按面板可选项配，
 * 各 `STRIPE_*` 与同步取值各配各的，传结算通道值 `STRIPE` 会被服务端拒；可配的取值取 §7.8.8 可选列表。
 *
 * **两步写**：字节先经 §7.8.7 `POST /payment-method-icons` 上传拿 `icon_asset_id`（该端点不写 DB），
 * 再经 §7.8.6 `PUT /payment-method-settings` 把标识挂到行上。上传走 `uploadImageFile`（multipart
 * 要让浏览器自设 boundary，apiRequest 恒设 JSON Content-Type 会破坏它），落库走 apiRequest。
 *
 * **`icon_asset_id: null` = 清空**，且服务端有成员前置校验：目标支付方式仍是任一策略组成员时拒绝
 * （§7.8.6）。要清空先去策略面板把它移出成员集合 —— 本层不预判，让服务端回 422，UI 照实显示。
 */

import type {
  PaymentMethodSettingResponse,
  UploadPaymentMethodIconResponse,
  UpsertPaymentMethodSettingRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';
import { uploadImageFile } from '~/api/upload-image';

export const paymentMethodSettingsApi = {
  /** 列某 App 全部未软删设置行（§7.8.5，不分页；未配置图标的支付方式可能整行缺失）*/
  list: (appId: string) =>
    apiRequest<PaymentMethodSettingResponse[]>({
      method: 'GET',
      path: '/api/v1/payment-method-settings',
      query: { app_id: appId },
    }),
  /** upsert 单个支付方式的图标与可选底色（§7.8.6，operator+ mfa）；`icon_asset_id: null` = 清空 */
  upsert: (body: UpsertPaymentMethodSettingRequest) =>
    apiRequest<PaymentMethodSettingResponse>({
      method: 'PUT',
      path: '/api/v1/payment-method-settings',
      body,
    }),
  /** 上传图标字节（§7.8.7，operator+ mfa）：png / webp ≤ 512KB，恒生成新资产、不覆盖既有 */
  uploadIcon: (file: File) =>
    uploadImageFile<UploadPaymentMethodIconResponse>('/api/v1/payment-method-icons', file),
};
